import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class Title extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { titleArr, src, url },
        } = this.props;

        return (
            <div className={styles.title}>
                <div className={styles.title_box}>
                    {titleArr.map((item, index) => (
                        <a key={index} href={item.url} target="_blank">
                            {item.title}
                        </a>
                    ))}
                </div>
                <div className={styles.title_tg}>
                    <a href={url} target="_blank">
                        <img src={src} />
                    </a>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Title);
